import { useMutation } from '@tanstack/react-query';
import { useAderenciaPrecosStore } from '../AderenciaPrecos.store';

import * as service from '../services';
import { AderenciaBigNumbersBody } from '../types';
import { useState } from 'react';

export const useAderenciaBigNumbers = () => {
  const [aderenciaStatus, setAderenciaStatus] = useState(200);
  const { setAderenciaPrecosState } = useAderenciaPrecosStore();

  const getAderenciaBigNumbersRequest = async (data: AderenciaBigNumbersBody) => {
    const resp = await service.getAderenciaBigNumbers(data);
    return resp;
  };

  const successAction = data => {
    setAderenciaStatus(data.status);
    setAderenciaPrecosState('aderenciaBigNumbersData', data?.data);
  };

  const mutate = useMutation({
    mutationFn: getAderenciaBigNumbersRequest,
    onSuccess: data => successAction(data),
  });

  return {
    aderenciaStatus,
    isLoadingBigNumbers: mutate.isPending,
    handleGetAderenciaBigNumbers: mutate.mutateAsync,
  };
};
